import React from 'react';
import {Link} from 'react-router-dom';

const Footer = () => (
  <footer className="bg-stone-950 text-stone-500 py-14 border-t border-stone-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-3 gap-10 mb-10 pb-10 border-b border-stone-900">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-xl bg-stone-800 border border-stone-700 flex items-center justify-center">
              <span className="text-amber-400 font-bold text-lg font-serif">M</span>
            </div>
            <span className="font-semibold text-xl text-white tracking-tight font-serif">
              MyMD <span className="font-light text-stone-500 italic">Weight Loss</span>
            </span>
          </div>
          <p className="text-sm font-light leading-relaxed text-stone-500 max-w-xs mb-4">
            Physician-supervised weight loss coaching and administrative services delivered remotely, directly to you.
          </p>
          <div className="text-xs font-light leading-relaxed text-stone-600 space-y-1">
            <p className="font-semibold text-stone-500">MyMD Weight Loss</p>
            <p>7250 Pierson Dr, Mobile, AL 36619</p>
            <p>
              <a href="tel:2512352120" className="hover:text-amber-400 transition-colors">251-235-2120</a>
            </p>
            <p>
              <a href="mailto:support@joinmymd.com" className="hover:text-amber-400 transition-colors">support@joinmymd.com</a>
            </p>
            <p>
              <a href="https://joinmymd.com" className="hover:text-amber-400 transition-colors">joinmymd.com</a>
            </p>
          </div>
        </div>
        <div>
          <h4 className="text-stone-300 font-bold text-xs uppercase tracking-widest mb-4">Program</h4>
          <div className="space-y-2.5 text-sm">
            <p className="hover:text-amber-400 cursor-pointer transition-colors">How It Works</p>
            <p className="hover:text-amber-400 cursor-pointer transition-colors">The Program</p>
            <p className="hover:text-amber-400 cursor-pointer transition-colors">FAQ</p>
          </div>
        </div>
        <div>
          <h4 className="text-stone-300 font-bold text-xs uppercase tracking-widest mb-4">Legal</h4>
          <div className="space-y-2.5 text-sm mb-6">
            <Link to="/privacy" className="block hover:text-amber-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="block hover:text-amber-400 transition-colors">Terms of Service</Link>
            <Link to="/refund-policy" className="block hover:text-amber-400 transition-colors">Refund Policy</Link>
          </div>
          <p className="text-xs font-light leading-relaxed text-stone-600">
            *Individual results vary. Medical clearance handled by independent providers.
          </p>
        </div>
      </div>

      <div className="bg-stone-900/50 border border-stone-800 rounded-2xl px-6 py-5 mb-8 text-xs font-light leading-relaxed text-stone-500">
        <p className="font-semibold text-stone-400 mb-1 uppercase tracking-widest text-[10px]">Independent Clinical Entity Disclaimer</p>
        <p>
          JoinMyMD is a wellness coaching and administrative service provider. Medical evaluations and prescriptions are conducted by independent, board-certified healthcare professionals licensed in your state. JoinMyMD does not practice medicine, employ physicians, or direct clinical care. Individual results vary; medical clearance is handled solely by your independent treating provider.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium">
        <p className="text-stone-600">&copy; {new Date().getFullYear()} MyMD Weight Loss. All rights reserved. &mdash; <a href="https://joinmymd.com" className="hover:text-amber-400 transition-colors">joinmymd.com</a></p>
        <div className="flex gap-6 uppercase tracking-widest text-stone-600">
          <Link to="/privacy" className="hover:text-amber-400 transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-amber-400 transition-colors">Terms</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;